import { ParseQuery } from './parse-query';

import './../extensions/reg-exp+escape';

import { Collection } from './../data';

export class CollectionQuery extends ParseQuery<Collection> {
  constructor() {
    super(Collection);
  }

  public search(searchText: string) {
    this.matches(Collection.NAME_KEY, RegExp.escape(searchText), 'i');
    return this;
  }
}